import { hasEvaluationInput } from './assessmentMode';

export const isStep1EvaluationComplete = (row = {}) =>
  Number(row?.eval_id) > 0 && (Number(row?.direct_risk_score) > 0 ||
    [row?.frequency_id, row?.importancy_id].every((value) => Number(value) > 0));

export const getReadyLineEvaluations = (items = [], getForm, mode = 'score') =>
  items.filter((item) => {
    if (isStep1EvaluationComplete(item)) return false;
    const form = getForm(item) || {};
    return hasEvaluationInput(form, mode);
  });

export const isStep1RowComplete = (row = {}) => {
  if (!row?.__lineGroup) return isStep1EvaluationComplete(row);
  const items = Array.isArray(row.items) ? row.items : [];
  return items.length > 0 && items.every(isStep1EvaluationComplete);
};
